import { render, staticRenderFns } from "./EditLibraryText.vue?vue&type=template&id=6a8935bf&scoped=true&"
import script from "./EditLibraryText.vue?vue&type=script&lang=js&"
export * from "./EditLibraryText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8935bf",
  null
  
)

export default component.exports